import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import SequenceMetrics from "./components/SequenceMetrics";

export default ({
  open,
  onClose,
  sequenceId,
  companyId,
  getToken,
  eventListener,
}: {
  open: boolean;
  onClose: () => void;
  sequenceId: string;
  companyId: string;
  getToken: () => Promise<string>;
  eventListener: Function;
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      aria-labelledby="metrics-dialog-title"
    >
      <DialogTitle
        id="metrics-dialog-title"
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Sequence Metrics</Typography>
          <IconButton onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <SequenceMetrics
          sequenceId={sequenceId}
          companyId={companyId}
          getToken={getToken}
          eventListener={eventListener}
          showTitle={false}
        />
      </DialogContent>
    </Dialog>
  );
};
